




















































































import { defineComponent, reactive, SetupContext, ref, toRef, toRefs, watch, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { Student, SearchCondition } from "../../modules/teacher/ResearchIdList"

export interface Data {
  condition: SearchCondition
  students: Student[]
  totalCount: number
  isShow: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * ref
     ******************************/
    const modalResetPasswordRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      students: new Array<Student>(),
      totalCount: 0,
      isShow: false,
      errors: [],
    });

    /******************************
     * methods
     ******************************/

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/research_id_list?${Common.BuildQuery(state.condition, 'search_student')}`).then(response => {
        state.students = response.data.students.map((x: any) => new Student(x));
        state.totalCount = state.students.length > 0 ? state.students[0].at_full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /****************************************
     * 指定されたページに遷移
     ****************************************/
    
    const to = (page: string) => {
      context.root.$router.push(page).catch(err => {});
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      modalResetPasswordRef,
      searchClick,
      search,
      clearCondition,
      changePage,
      to,
    };
  },
})
